/**
 * @param {*} employmentBlob
 * @param {*} forPublish
 * @returns true on success, false if any employee has multiple roles at any tenant
 */
export function cleanEmployment (employmentBlob, forPublish = false) {
  if (forPublish) {
    if (hasInvalidRoles(employmentBlob)) {
      return false
    }
  }
  return true
}

/**
 * @returns true if there are duplicate truthy grantObjects on an employee
 */
function hasInvalidRoles (employmentBlob) {
  const employees = employmentBlob.employees
  for (let i = 0; i < employees.length; i++) {
    const roles = employees[i].grantedRoles || []
    const grantObjects = roles.filter(r => r.grantObject).map(r => r.grantObject)
    const uniques = new Set(grantObjects)
    if (uniques.size !== grantObjects.length) {
      return true
    }
  }
  return false
}
